"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CurrentUserManagerActions;
(function (CurrentUserManagerActions) {
    CurrentUserManagerActions["LoggedIn"] = "LoggedIn";
    CurrentUserManagerActions["LoggedOut"] = "LoggedOut";
})(CurrentUserManagerActions || (CurrentUserManagerActions = {}));
exports.default = CurrentUserManagerActions;
